import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Chip from 'material-ui/Chip';
import Avatar from 'material-ui/Avatar';
import getTheme from '../MuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import gmbLogo from '../../assets/google-my-business-logo.svg';
import * as styles from './FormElements.scss';
import xLogo from '../../assets/x-logo-white.png';

var LLSocialAccountChip = /*#__PURE__*/function (_Component) {
  _inherits(LLSocialAccountChip, _Component);

  var _super = _createSuper(LLSocialAccountChip);

  function LLSocialAccountChip() {
    var _this;

    _classCallCheck(this, LLSocialAccountChip);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "socialAccountBackgroundColor", function (sa) {
      if (sa.platform.indexOf('Facebook') === 0) {
        return '#3b5998';
      } else if (sa.platform.indexOf('LinkedIn') === 0) {
        return '#0077b5';
      } else if (sa.platform === 'Twitter') {
        return '#1da1f2';
      }

      return '#c13584';
    });

    _defineProperty(_assertThisInitialized(_this), "socialAccountIcon", function (sa) {
      if (sa.platform.indexOf('Facebook') === 0) {
        return /*#__PURE__*/React.createElement("i", {
          className: "fa fa-facebook ".concat(styles.socialChipIcon)
        });
      } else if (sa.platform.indexOf('Google') === 0) {
        return /*#__PURE__*/React.createElement("i", {
          className: "fa fa-google ".concat(styles.socialChipIcon)
        });
      } else if (sa.platform.indexOf('LinkedIn') === 0) {
        return /*#__PURE__*/React.createElement("i", {
          className: "fa fa-linkedin ".concat(styles.socialChipIcon)
        });
      } else if (sa.platform === 'Twitter') {
        return /*#__PURE__*/React.createElement("img", {
          src: xLogo,
          className: "fa fa-twitter ".concat(styles.socialChipIcon),
          style: {
            display: 'border-box'
          }
        });
      }

      return /*#__PURE__*/React.createElement("i", {
        className: "fa fa-instagram ".concat(styles.socialChipIcon)
      });
    });

    return _this;
  }

  _createClass(LLSocialAccountChip, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(Chip, {
        onClick: this.props.onClick,
        labelStyle: {
          lineHeight: '28px',
          paddingLeft: 0
        },
        style: _objectSpread({}, this.props.style),
        onRequestDelete: this.props.requestDelete,
        className: styles.chip
      }, this.props.socialAccount && this.socialAccountIcon(this.props.socialAccount), this.props.socialAccount && this.props.socialAccount.username);
    }
  }]);

  return LLSocialAccountChip;
}(Component);

_defineProperty(LLSocialAccountChip, "propTypes", {
  style: PropTypes.object,
  fullWidth: PropTypes.bool,
  onClick: PropTypes.func,
  socialAccount: PropTypes.object.isRequired,
  requestDelete: PropTypes.func
});

_defineProperty(LLSocialAccountChip, "defaultProps", {
  style: {},
  onClick: undefined,
  backgroundColor: undefined,
  socialAccount: undefined,
  requestDelete: null
});

export { LLSocialAccountChip as default };